module.exports = __webpack_public_path__ + "static/media/allGroups.11b6199b.svg";